export const ATTEMPT_LOGIN = 'ATTEMPT_LOGIN';
export const UPDATE_LOGIN_STATUS = 'UPDATE_LOGIN_STATUS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const RECEIVED_NOTIFICATIONS = 'RECEIVED_NOTIFICATIONS';
export const ACKNOWLEDGE_NOTIFICATIONS = 'ACKNOWLEDGE_NOTIFICATIONS'
export const RECEIVED_SUPERVISOR_NOTIFICATIONS = 'RECEIVED_SUPERVISOR_NOTIFICATIONS'
export const RECEIVED_ACKNOWLEDGE = 'RECEIVED_ACKNOWLEDGE'
export const NOTIFICATION_DATETIME_FORMAT = 'MMM D YYYY';
export const AGENT_LOCATION_FLAG = 'AGENT_LOCATION_FLAG';
export const RECEIVE_AGENT_LOCATION_FLAG = 'RECEIVE_AGENT_LOCATION_FLAG';
export const GET_AGENT_VERIFICATION_EMAIL = 'GET_AGENT_VERIFICATION_EMAIL';


// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js